import React from 'react';

import './ProgressBar.scss';

export const ProgressBar = ({ percent = 0 }) => (
  <div className="progressbar-container">
    <div className="filler" style={{ width: `${percent}%` }} />
  </div>
);
